import React, { useState, useEffect } from "react";

import useUserMissionState from "./useUserMissionState";
import CenteredLoadingIcon from "../../common_components/CenteredLoadingIcon";
import MissionNotApplied from "./MissionNotApplied";
import MissionScreener from "./MissionScreener";
import MissionInReview from "./MissionInReview";
import MissionSurvey from "./MissionSurvey";
import MissionSchedule from "./MissionSchedule";
import MissionScheduled from "./MissionScheduled";
import MissionCompleted from "./MissionCompleted";
import MissionRejected from "./MissionRejected";


function MissionContents({ mission }) {
    const [refreshStatus, setRefreshStatus] = useState(0);
    const { userMissionState, isLoading } = useUserMissionState(mission.id, refreshStatus);

    function refreshMissionStatus() {
        setRefreshStatus(refreshStatus + 1);
    }

    useEffect(() => {
        document.title = `${mission.name} | Despark`;
    }, []);

    if (isLoading) return <CenteredLoadingIcon />;

    switch (userMissionState) {
        case 'not_applied':
            return <MissionNotApplied mission={mission} userMissionState={userMissionState} refreshMissionStatus={refreshMissionStatus} />;
        case 'prescreen':
            return <MissionScreener mission={mission} userMissionState={userMissionState} refreshMissionStatus={refreshMissionStatus} />;
        case 'in_review':
            return <MissionInReview mission={mission} userMissionState={userMissionState} refreshMissionStatus={refreshMissionStatus} />;
        case 'applied':
            if (mission.format_basic == "interview") {
                return <MissionSchedule mission={mission} userMissionState={userMissionState} refreshMissionStatus={refreshMissionStatus} />;
            } else {
                return <MissionSurvey mission={mission} userMissionState={userMissionState} refreshMissionStatus={refreshMissionStatus} />;
            }
        case 'scheduled':
            return <MissionScheduled mission={mission} userMissionState={userMissionState} refreshMissionStatus={refreshMissionStatus} />;
        case 'completed':
            return <MissionCompleted mission={mission} userMissionState={userMissionState} refreshMissionStatus={refreshMissionStatus} />;
        case 'rejected':
            return <MissionRejected mission={mission} userMissionState={userMissionState} refreshMissionStatus={refreshMissionStatus} />;
        case null:
            return <div>Unknown mission </div>;
        // default:
        //     return <UnknownMissionState />;
    }
}

export default MissionContents;